import stringHelper from 'app/shared/utils/stringHelper';

const minPhotosMFH = 1;

const requiredFieldNames = {
    contactEmail: 'contactEmail',
    contactName: 'contactName',
    contactPhone: 'contactPhone',
    description: 'description',
    floorplans: 'floorplans',
    forRentBy: 'forRentBy',
    listingTitle: 'listingTitle',
    leaseDuration: 'leaseDuration',
    photos: 'photos',
    price: 'price',
    isApplicationsAccepted: 'isApplicationsAccepted',
};

const singleFamilyRequiredFields = [
    requiredFieldNames.price,
    requiredFieldNames.floorplans,
    requiredFieldNames.leaseDuration,
    requiredFieldNames.contactName,
    requiredFieldNames.contactEmail,
    requiredFieldNames.contactPhone,
    requiredFieldNames.forRentBy,
];

const multiFamilyRequiredFields = [
    requiredFieldNames.listingTitle,
    requiredFieldNames.description,
    requiredFieldNames.photos,
    requiredFieldNames.floorplans,
    requiredFieldNames.contactName,
    requiredFieldNames.contactEmail,
    requiredFieldNames.contactPhone,
    requiredFieldNames.forRentBy,
];

const requiredPropertyErrorMessages = {
    listingTitle: 'Please enter the property name', // MF requirement
    price: 'Please enter a monthly rent', // Only required if NOT MF listing
    leaseDuration: 'Please select a lease duration',
    description: 'Please enter the property description', // MF requirement
    photos: `Please upload at least ${stringHelper.pluralize(minPhotosMFH, 'photo', 'photos')}`, // MF requirement
    contactName: 'Please enter a contact name',
    contactEmail: 'Please enter your email address',
    contactPhone: 'Please enter your phone number',
    forRentBy: 'Please select an option for "For Rent By"',
    isApplicationsAccepted: 'Please select an option for rental applications.',
};

const requiredFloorplanErrorMessages = {
    name: 'Please enter a name for your floor plan',
    beds: 'Please select the number of bedrooms',
    baths: 'Please select the number of bathrooms',
    active: 'At least one floor plan or unit must be active',
};

const requiredUnitErrorMessages = {
    name: 'Please enter a unit number',
    active: 'At least one floor plan or unit must be active',
};

const unitErrorObjBlank = {
    dateAvailable: null,
    active: null,
    name: null,
    price: null,
    sqft: null,
};

const floorplanErrorObjBlank = {
    active: null,
    beds: null,
    baths: null,
    price: null,
    lowPrice: null,
    highPrice: null,
    sqft: null,
    units: [],
};

export {
    floorplanErrorObjBlank,
    minPhotosMFH,
    multiFamilyRequiredFields,
    requiredFieldNames,
    requiredFloorplanErrorMessages,
    requiredPropertyErrorMessages,
    requiredUnitErrorMessages,
    singleFamilyRequiredFields,
    unitErrorObjBlank,
};
